import * as React from 'react'
import { TagCloudEntry } from './types'

export const tagRenderer = (tag: TagCloudEntry, size: number, color: string, selectedTag: TagCloudEntry) => {
  const fontSize = size + 'px'
  const key = tag.value
  const isSelected = selectedTag && ( selectedTag.value === tag.value)

  const tagStyle = {
    ...styles,
    color,
    fontSize,
  }

  const tagClassName = isSelected ? 'tag-cloud-tag selected' : 'tag-cloud-tag'
  return (
    <span className={tagClassName} style={tagStyle} key={key}>
      {tag.value}
    </span>
  )
}

const styles = {
  margin: '0px 3px',
  verticalAlign: 'middle',
  display: 'inline-block',
}

